module.exports = __webpack_public_path__ + "img/ziti_liucheng.26b6506b.png";